// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-container {

    margin-bottom: 120px;
}
.table-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
}

.custom-table tr {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    /* Adds gap between rows */
    box-shadow: -2px 1px 10px -2px #00000040;
    /* Adds shadow to each row */
    background-color: white;
    /* Ensure the row has a background color */
    border-radius: 5px;
    margin-right: 2px;
    margin-left: 2px;
}

.custom-table th,
.custom-table td {
    padding: 12px;
    text-align: left;
    flex: 1 1; /* Equal width for all columns */
    display: flex;
    align-items: center; /* Vertically center content */
}

.custom-table th.checkbox-header,
.custom-table td.checkbox-cell {
    flex: 0.5 1; /* Slightly smaller for checkbox */
    display: flex;
    align-items: center;
    justify-content: left;
}

.custom-table th {
    color: #3b454f;
    font-weight: 600;
    font-size: 1.125rem;
    border-bottom: 5px solid #102a62;
    /* Pink bottom border */
    box-shadow: none;
    /* No shadow for header */
    background-color: transparent;
    /* No background color */
    align-items: center; /* Vertically center header text */
    cursor: pointer;
}

.custom-table th:hover {
    background-color: #f1f1f1;
}

.custom-table td {
    color: #3b454f;
    font-weight: 400;
}

.custom-table tr:hover {
    background-color: #f1f1f1;
}

.btn {
    padding: 5px 5px;
    margin-right: 0px;
    border: none;
    cursor: pointer;
}

.edit-btn {
    color: white;
    cursor: pointer;
}

.delete-btn {
    color: white;
    cursor: pointer;
}

/* Add this CSS to align the sort icon and labels */
.custom-table th div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/SurveyManagement/SurveyTable.css"],"names":[],"mappings":"AAAA;;IAEI,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,0BAA0B;IAC1B,wCAAwC;IACxC,4BAA4B;IAC5B,uBAAuB;IACvB,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,SAAO,EAAE,gCAAgC;IACzC,aAAa;IACb,mBAAmB,EAAE,8BAA8B;AACvD;;AAEA;;IAEI,WAAS,EAAE,kCAAkC;IAC7C,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;IAC7B,wBAAwB;IACxB,mBAAmB,EAAE,kCAAkC;IACvD,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,cAAc;AAClB","sourcesContent":[".survey-container {\n\n    margin-bottom: 120px;\n}\n.table-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n}\n\n.custom-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.custom-table tr {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    /* Adds gap between rows */\n    box-shadow: -2px 1px 10px -2px #00000040;\n    /* Adds shadow to each row */\n    background-color: white;\n    /* Ensure the row has a background color */\n    border-radius: 5px;\n    margin-right: 2px;\n    margin-left: 2px;\n}\n\n.custom-table th,\n.custom-table td {\n    padding: 12px;\n    text-align: left;\n    flex: 1; /* Equal width for all columns */\n    display: flex;\n    align-items: center; /* Vertically center content */\n}\n\n.custom-table th.checkbox-header,\n.custom-table td.checkbox-cell {\n    flex: 0.5; /* Slightly smaller for checkbox */\n    display: flex;\n    align-items: center;\n    justify-content: left;\n}\n\n.custom-table th {\n    color: #3b454f;\n    font-weight: 600;\n    font-size: 1.125rem;\n    border-bottom: 5px solid #102a62;\n    /* Pink bottom border */\n    box-shadow: none;\n    /* No shadow for header */\n    background-color: transparent;\n    /* No background color */\n    align-items: center; /* Vertically center header text */\n    cursor: pointer;\n}\n\n.custom-table th:hover {\n    background-color: #f1f1f1;\n}\n\n.custom-table td {\n    color: #3b454f;\n    font-weight: 400;\n}\n\n.custom-table tr:hover {\n    background-color: #f1f1f1;\n}\n\n.btn {\n    padding: 5px 5px;\n    margin-right: 0px;\n    border: none;\n    cursor: pointer;\n}\n\n.edit-btn {\n    color: white;\n    cursor: pointer;\n}\n\n.delete-btn {\n    color: white;\n    cursor: pointer;\n}\n\n/* Add this CSS to align the sort icon and labels */\n.custom-table th div {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 0 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
